import PropTypes from 'prop-types';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPlay,
} from '@fortawesome/free-solid-svg-icons';
import './VideoPlayerItem.scss';

export default class VideoPlayerItem extends React.PureComponent {
  static propTypes = {
    media: PropTypes.object,
    onSelect: PropTypes.func,
    selectedId: PropTypes.string,
  }

  static defaultProps = {
    media: {},
    onSelect: null,
    selectedId: null,
  }

  constructor(props) {
    super(props);
    this.state = {
      isSelected: this.props.selectedId === this.props.media._id,
    };
  }


  handleSelect =(e) => {
    e.preventDefault();
    const {
      media,
      onSelect,
    } = this.props;

    if (onSelect) onSelect(media._id);
  }

  setIsSelected = (isSelected) => {
    this.setState({ isSelected });
  }

  render() {
    const {
      author,
      projectThumbFileUrl,
      title,
      _id,
    } = this.props.media;

    const {
      selectedId,
    } = this.props;

    const isSelected = selectedId === _id;
    const imgSrc = projectThumbFileUrl || `${process.env.REACT_APP_PREFIX}/iconTitled.png`;
    return (
      <div className={`crowdaa-VideoPlayerItem ${isSelected ? 'crowdaa-VideoPlayerItem--selected ' : ''}col-md-4`}>
        <div
          className="crowdaa-VideoPlayerItem__button"
          onClick={this.handleSelect}
          onKeyUp={this.handleSelect}
          role="button"
          tabIndex={0}
          ref={(node) => { this.node = node; }}
        >
          <div className="crowdaa-VideoPlayerItem__inner">
            <div className="crowdaa-VideoPlayerItem__picture mb-1" style={{
              backgroundImage: `url(${imgSrc})`,
            }} >
              <FontAwesomeIcon size='4x' icon={faPlay} />
            </div>
            <br />
            <span>{title}</span>
            <p><i>From </i>{author}</p>
          </div>
        </div>
      </div>
    );
  }
}
